import React from "react";

const About = () => (
  <section id="about" className="about">
    <h2 style={{ color: "var(--accent)", marginTop: 0 }}>About</h2>
    <p>Reh Dogg Games Plus creates free and premium indie games for mobile and desktop players.</p>
  </section>
);

export default About;
